import React from "react";
import PropTypes from "prop-types";
import { withFormik, Field } from "formik";
import { useTranslation } from "react-i18next";
import {
  dataModel,
  validationDataModel,
  setInitialValues,
} from "./sectorForm.data.form";
import PATHS from "../../../../constants/paths";
import { useNavigate } from "react-router-dom";
import {
  InputText,
  InputSelect,
  InputCheck,
  BreadCrumb,
} from "@de-prado-dev/react-component-library";

const SectorForm = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { handleSubmit, onback, edit, locations, onChangeVivero, viveros } =
    props;
  const breads = [
    { label: t("home"), path: PATHS.HOME },
    { label: t("forms.sector.title"), path: PATHS.LIST_sector },
    { label: edit ? t("forms.sector.titleEdit") : t("forms.sector.titleNew") },
  ];

  return (
    <>
      <div className="row justify-content-center">
        <div className="col-12 col-md-11">
          <h3 className="title">
            {edit ? t("forms.sector.titleEdit") : t("forms.sector.titleNew")}
          </h3>
        </div>
      </div>
      <BreadCrumb items={breads} />
      <div className="row justify-content-center  ">
        <div className="col-12 col-md-5">
          <form autoComplete="off" onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-12">
                <Field
                  id="viveroUuid"
                  name="viveroUuid"
                  labelField={t("forms.code.labels.vivero")}
                  component={InputSelect}
                  placeholder=""
                  optionLabel="label"
                  optionValue="code"
                  options={viveros.map((item) => ({
                    ...item,
                    label: t(item.label),
                  }))}
                  onChangeValue={(value) => {
                    onChangeVivero(value);
                    props.setFieldValue("locationUuid", "", true);
                  }}
                  addOptionEmpty
                  classNamePrefix="dark"
                />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-12">
                <Field
                  id="locationUuid"
                  name="locationUuid"
                  labelField={t("forms.sector.labels.location")}
                  placeholder=""
                  component={InputSelect}
                  optionLabel="label"
                  optionValue="code"
                  options={locations.map((item) => ({
                    ...item,
                    label: t(item.label),
                  }))}
                  classNamePrefix="dark"
                  mandatory
                />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-12">
                <Field
                  id="name"
                  className="form-control"
                  labelField={t("forms.sector.labels.name")}
                  name="name"
                  placeholder=""
                  component={InputText}
                  fieldType="text"
                  mandatory
                />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-12">
                <Field
                  id="rows"
                  className="form-control"
                  labelField={t("forms.sector.labels.rows")}
                  name="rows"
                  placeholder=""
                  component={InputText}
                  fieldType="number"
                  mandatory
                />
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-12">
                <Field
                  id="rowsAB"
                  labelField={t("forms.sector.labels.rowsAB")}
                  name="rowsAB"
                  placeholder=""
                  component={InputCheck}
                  mandatory
                />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-12">
                <Field
                  id="active"
                  labelField={t("forms.sector.labels.active")}
                  name="active"
                  placeholder=""
                  component={InputCheck}
                  mandatory
                />
              </div>
            </div>

            <div className="row justify-content-center">
              <div className="col-10 col-sm-11 text-center mt-5 mb-5">
                <button
                  type="button"
                  onClick={() => onback()}
                  className="btn btn-lg btn-primary me-2"
                >
                  {t("forms.sector.buttons.cancel")}
                </button>
                <button type="submit" className="btn btn-lg btn-secondary">
                  {t("forms.sector.buttons.save")}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

SectorForm.propTypes = {
  handleSubmit: PropTypes.func,
  initialValues: PropTypes.object,
  onback: PropTypes.func,
  edit: PropTypes.bool,
};

const SectorFormF = withFormik({
  mapPropsToValues: (props) => {
    if (props.initialValues) {
      return setInitialValues(props.initialValues);
    }
    return dataModel;
  },
  validationSchema: (props) => {
    return validationDataModel(props.edit);
  },
  handleSubmit: (values, { props, resetForm }) => {
    props.onSubmit(values, resetForm);
  },
  enableReinitialize: true,
  displayName: "SectorForm",
})(SectorForm);

export default SectorFormF;
